import { render, staticRenderFns } from "./MontagemCargaFormDetalhes.vue?vue&type=template&id=30f24b7e"
import script from "./MontagemCargaFormDetalhes.vue?vue&type=script&lang=js"
export * from "./MontagemCargaFormDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports